<img class="app-header__logo" src="{{assetsUrl}}/Portal/mine-os-black-logo.svg.svg" alt="Mine logo" (click)="onClick()">

<app-menu-temporary *ngIf="loggedIn$ | async"></app-menu-temporary>